import { render, staticRenderFns } from "./form6.vue?vue&type=template&id=bfef5afc&scoped=true&"
import script from "./form6.vue?vue&type=script&lang=js&"
export * from "./form6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfef5afc",
  null
  
)

export default component.exports